/**
 * Created by Karol Kluska on 10.11.17.
 */

angular
  .module('app')
  .constant('AGE_CATEGORY', {
    CAT1: 1,
    CAT2: 2,
    CAT3: 3
  });
